import React, {useEffect} from "react";
import {EditFormLabelErrorWrapper} from "../../Components/ReactTable/EditRecordForm";
import {getArrayValuesFromOptions} from "../../../utils/maybeAddLabelToOptions";
import _ from "lodash";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";

export function MarketParentageDropdownField({marketParentage, markets, label, form, id}) {

    const [filteredMarketsOptions, setFilteredMarketsOptions] = React.useState([])
    const [filteredMarketsValues, setFilteredMarketsValues] = React.useState([])

    useEffect(() => {
        const marketId = form.getValues('marketId');

        const isParentId = id === 'parentId' || id === 'parentMarketTagsForMaryAndAmy';
        const filterKey = isParentId ? 'childId' : 'parentId';
        const mapKey = isParentId ? 'parentId' : 'childId';

        const options = marketParentage.filter(option => option[filterKey] === marketId)

        const marketValues = getArrayValuesFromOptions(_.map(options, mapKey), markets)

        setFilteredMarketsOptions(markets)
        setFilteredMarketsValues(marketValues)
    }, [marketParentage, markets, id])

    useEffect(() => {
        form.setValue(id, filteredMarketsValues)
    }, [filteredMarketsValues])


    return (<EditFormLabelErrorWrapper
        id={id}
        form={form}
        label={label}
        isRequired={false}
        value={filteredMarketsValues}
    >
        <div data-testid={`${id}-form-dropdown-component-container`}>
            <SelectDropdown
                id={`edit-${id}-dropdown`}
                dataTestId={`edit-${id}-dropdown`}
                inputId={id}
                options={filteredMarketsOptions}
                selectValues={_.map(filteredMarketsValues, 'value')}
                isDisabled={true}
                isMulti
                isClearable={true}
            />
        </div>
    </EditFormLabelErrorWrapper>)


}
